class NfInstafeedVideo extends HTMLElement {
  constructor() {
    super();
    this.#init();
  }

  #init() {
    const button = this.querySelector('[data-mute-toggle]');
    const video = this.querySelector('video');

    if (!button || !video) return;

    button.addEventListener('click', () => {
      video.muted = !video.muted;
      button.setAttribute('aria-pressed', String(!video.muted));
      button.setAttribute(
        'aria-label',
        video.muted
          ? button.dataset.labelMuted
          : button.dataset.labelUnmuted
      );
    });
  }
}

if (!customElements.get('nf-instafeed-video')) {
  customElements.define('nf-instafeed-video', NfInstafeedVideo);
}
